<template>
  <div>
    <section class="mainsection">
      <div class="container-fluid" style="margin-top:20px;">
        <div class="row">
          <div class="col-md-3 d-sm-none d-md-block">
            <nav-bar-pbjt active="objek-pajak"></nav-bar-pbjt>
          </div>
          <div class="col-sm-pull-12 col-md-9">
            <div class="row justify-content-center">
              <div class="col-lg-12">
                <div class="alert alert-default">
                  <strong>Informasi!</strong> :
                  <ul>
                    <li>
                      Jika NPWPD Anda kosong saat Input data, pastikan objek pajak Anda Ada dan terdaftar sebagai jenis
                      pajak yang sesuai dengan pajak Anda
                    </li>
                    <li>
                      Hubungkan NPWPD Anda dengan cara memasukan nomor NPWPD pada menu Objek Pajak -> Hubungkan NPWPD
                    </li>
                  </ul>
                </div>
              </div>
              <div class="col-lg-12">
                <div class="row row-grid">

                  <div class="col-md col-sm-12">
                    <component :is="'a'" @click="$router.push('/pajak-barang-dan-jasa-tertentu/hotel')">
                      <card class="border-0 d-flex card-reklame" hover shadow
                        body-classes="text-center align-items-center d-flex justify-content-center">
                        <object data="/img/svg/4-Hotel.svg" type="image/svg+xml" class="text-white card-pajak"></object>
                        <h6 class="text-white text-uppercase title-inside-card" style="margin-top: 7px">Jasa Perhotelan
                        </h6>
                      </card>
                    </component>
                  </div>

                  <div class="col-md col-sm-12">
                    <component :is="'a'" @click="$router.push('/pajak-barang-dan-jasa-tertentu/restoran')">
                      <card class="border-0 d-flex card-restoran" hover shadow
                        body-classes="text-center align-items-center d-flex justify-content-center">
                        <object data="/img/svg/5-Restaurant.svg" type="image/svg+xml"
                          class="text-white card-pajak"></object>
                        <h6 class="text-white text-uppercase title-inside-card" style="margin-top: 7px">Jasa Makanan
                          dan/atau Minuman
                        </h6>
                      </card>
                    </component>
                  </div>

                  <div class="col-md col-sm-12">
                    <component :is="'a'" @click="$router.push('/pajak-barang-dan-jasa-tertentu/hiburan')">
                      <card class="border-0 d-flex card-air-tanah" hover shadow
                        body-classes="text-center align-items-center d-flex justify-content-center">
                        <object data="/img/svg/6-Pajak Hiburan.svg" type="image/svg+xml"
                          class="text-white card-pajak"></object>
                        <h6 class="text-white text-uppercase title-inside-card" style="margin-top: 7px">Jasa Kesenian dan Hiburan
                        </h6>
                      </card>
                    </component>
                  </div>

                  <div class="col-md col-sm-12">
                    <component :is="'a'" @click="$router.push('/pajak-barang-dan-jasa-tertentu/parkir')">
                      <card class="border-0 d-flex card-parkir" hover shadow
                        body-classes="text-center align-items-center d-flex justify-content-center">
                        <object data="/img/svg/3-Pajak Parkir.svg" type="image/svg+xml"
                          class="text-white card-pajak"></object>
                        <h6 class="text-white text-uppercase title-inside-card" style="margin-top: 7px">Jasa Parkir
                        </h6>
                      </card>
                    </component>
                  </div>

                  <div class="col-md col-sm-12">
                    <component :is="'a'" @click="$router.push('/pajak-barang-dan-jasa-tertentu/tenaga-listrik')">
                      <card class="border-0 d-flex card-ppj" hover shadow
                        body-classes="text-center align-items-center d-flex justify-content-center">
                        <object data="/img/svg/1-Peneranagan Jalan.svg" type="image/svg+xml"
                          class="text-white card-pajak"></object>
                        <h6 class="text-white text-uppercase title-inside-card" style="margin-top: 7px">Jasa Tenaga Listrik
                        </h6>
                      </card>
                    </component>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
  
<script>
import ModalInformasiPajak from "../GlobalPage/InformasiPajak";
import ModalWajibPajak from "../GlobalPage/WajibPajak";
import { Chart } from "highcharts-vue";
import Modal from "@/components/Modal.vue";
import navBarPbjt from "./navBarPbjt"
export default {
  name: "index-pajak",
  components: {
    ModalInformasiPajak,
    highcharts: Chart,
    ModalWajibPajak,
    Modal,
    navBarPbjt
  },
  data() {
    return {
      items: [],
      dasar_hukum: false,
      navToggle: false
    };
  },
  computed: {
    checkAkses() {
      if (this.$store.state.auth.status.loggedIn)
        return this.$store.state.auth.user.is_wajib_pajak;
      return false;
    },
    navActive() {
      return this.navToggle ? 'active' : ''
    }
  },
};
</script>
<style lang="scss" scoped>
.section-shaped .shape.shape-skew+.shape-container {
  padding-top: 9rem;
  padding-bottom: 14rem;
}

.card-hotel {
  height: 100%;
}
</style>
